export const translations = {
    testimonialsHeading: 'Co Mówią Czytelnicy TravelPack',
    testimonialsSubHeadline: `Opinie Użytkowników`,
};

export default translations;
